import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { t } from "i18next";
import { useContext } from "react";
import { PatientsContext } from "../Patients/PatientsContext";
import { AppointmentItem } from "./LinkPatientRecordsModal/AppointmentItem";
import { EncounterItem } from "./LinkPatientRecordsModal/EncounterItem";
import RadiologyReportCard from "../Chat/Message/RadiologyReportCard";
import { useApplyReportTag } from "../Chat/Message/RadiologyReportCard/useApplyReportTag";
export var AttachmentsView = function AttachmentsView(_ref) {
  var onCollapse = _ref.onCollapse,
    reports = _ref.reports,
    encounters = _ref.encounters,
    appointments = _ref.appointments,
    linkedResources = _ref.linkedResources,
    patient_uid = _ref.patient_uid;
  var _ref2 = useContext(PatientsContext),
    customFields = _ref2.customFields,
    currentPatient = _ref2.currentPatient,
    patientTags = _ref2.patientTags;
  var _useApplyReportTag = useApplyReportTag({
      patientId: patient_uid !== null && patient_uid !== void 0 ? patient_uid : currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_uid
    }),
    onApplyTag = _useApplyReportTag.onApplyTag,
    applyingTagId = _useApplyReportTag.applyingTagId,
    buildCardData = _useApplyReportTag.buildCardData;
  return /*#__PURE__*/React.createElement("div", {
    className: "absolute h-full left-0 top-0 dark:bg-[#19242F] bg-[#E8E9EA] overflow-visible rounded-tl-12 z-50 min-w-[40vw] -translate-x-full flex flex-col border-l border-t border-gray-700"
  }, /*#__PURE__*/React.createElement("div", {
    className: "py-5 px-6 flex justify-between dark:bg-[#202A35] bg-white rounded-tl-12 shrink-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "dark:text-gray-100 text-gray-900"
  }, t("label.task_context")), /*#__PURE__*/React.createElement("button", {
    className: "text-gray-600 text-[14px]",
    onClick: onCollapse
  }, t("label.collapse"))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col overflow-y-auto flex-1 min-h-0"
  }, reports.length > 0 && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("h3", {
    className: "text-md font-semibold text-gray-400 uppercase tracking-[0.16px] px-5 py-3 bg-gray-100 dark:bg-gray-900"
  }, t("reports")), /*#__PURE__*/React.createElement("div", {
    className: "m-5 space-y-5"
  }, reports.map(function (report) {
    return /*#__PURE__*/React.createElement(RadiologyReportCard, {
      key: report.id,
      data: buildCardData(report, customFields || [], patientTags || []),
      onApplyTag: onApplyTag,
      applyingTagId: applyingTagId
    });
  }))), appointments.length > 0 && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("h3", {
    className: "text-md font-semibold text-gray-400 uppercase tracking-[0.16px] px-5 py-3 bg-gray-100 dark:bg-gray-900"
  }, t("appointments")), /*#__PURE__*/React.createElement("div", {
    className: "m-5 space-y-5"
  }, appointments.map(function (appointment) {
    return /*#__PURE__*/React.createElement(AppointmentItem, _extends({
      key: appointment.fhir_id
    }, appointment));
  }))), encounters.length > 0 && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("h3", {
    className: "text-md font-semibold text-gray-400 uppercase tracking-[0.16px] px-5 py-3 bg-gray-100 dark:bg-gray-900"
  }, t("encounters")), /*#__PURE__*/React.createElement("div", {
    className: "m-5 space-y-5"
  }, encounters.map(function (encounter) {
    return /*#__PURE__*/React.createElement(EncounterItem, {
      key: encounter.fhir_id,
      encounter: encounter
    });
  })))));
};